/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2020/6/22
 */
import { hzRoutes } from '../plugin-hz/routes';


export function patchRoutes({ routes }) {
  return routes.push(...hzRoutes)
}
